// extracted by mini-css-extract-plugin
module.exports = {"faq":"FaqScreen_faq__2Zprw","contact":"FaqScreen_contact__2LJ38","btn":"FaqScreen_btn__PGuaH","subtitle":"FaqScreen_subtitle__1BGD2"};